<!--
 * @Author: Tang Hao
 * @Date: 2024-07-05 15:51:51
 * @LastEditors: Tang Hao
 * @LastEditTime: 2025-04-01 14:42:54
 * @Description:
-->
<script>
import TablePage from '@/found/components/table_page';

export default {
  extends: TablePage,
  components: {
  },
  data() {
    return {
      // requestType: 'POST',
    };
  },
  mounted() {
    this.getConfigList('cps_financial_statistics_list');
  },
  methods: {

  },
};
</script>
